// Sanitize HTML produced by the RichTextEditor before rendering it on
// public pages. Allows the limited set of tags/attributes the editor can
// produce; strips everything else. Even though the editor schema constrains
// output, we sanitize at render time as defense-in-depth (an attacker could
// submit raw HTML directly to the API).
import DOMPurify from "dompurify";

const ALLOWED_TAGS = [
  "p",
  "br",
  "strong",
  "b",
  "em",
  "i",
  "s",
  "u",
  "ul",
  "ol",
  "li",
  "a",
];

const ALLOWED_ATTR = ["href", "target", "rel"];

export function sanitizeRichText(html: string): string {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    // Force-link relations to avoid abusing target=_blank.
    ADD_ATTR: ["target"],
  });
}
